<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span>Редактирование пункта меню</span>
    </div>

    <v-form ref="formFirst">
      <div class="container-block">

        <div>
          <v-text-field label="Название" required type="text" outlined :rules="rules"
            v-model="appSection.name"></v-text-field>
        </div>
        <div>
          <v-text-field label="Короткое название" required type="text" outlined counter="11" maxlength="11" :rules="rules"
            v-model="appSection.shortName"></v-text-field>
        </div>
        <div>
          <v-text-field label="Заголовок экрана" required type="text" outlined :rules="rules" v-model="appSection.title"
            counter="25" maxlength="25"></v-text-field>
        </div>
        <div v-if="appSection.isRemovable">
          <v-autocomplete :items="pages" outlined item-text="title" item-value="id" clearable v-model="appSection.pageId"
            label="Ссылка на страницу"></v-autocomplete>
          <!-- v-model="appSection.page.id" -->
        </div>
        <div class="d-flex">
          <v-text-field label="Ключ" required type="text" outlined :disabled="disabledKey" :rules="rules"
            v-model="appSection.key"></v-text-field>
          <div v-if="appSection.isRemovable">
            <v-icon v-if="disabledKey" @click="dialogDisable = true"
              style="margin: 16px 0 0 16px; cursor: pointer">mdi-lock</v-icon>
            <v-icon v-else @click="disabledKey = true"
              style="margin: 16px 0 0 16px; cursor: pointer">mdi-lock-open</v-icon>
          </div>

          <v-dialog width="600px" height="auto" persistent v-model="dialogDisable">
            <v-card>
              <v-card-title class="dialog-title">
                <span class="title">Точно хотите редактировать ключ?</span>
                <v-icon @click="dialogDisable = false">mdi-close</v-icon>
              </v-card-title>
              <v-card-text class="dialog-description">
                <div class="dialog-description-text-container">
                  Ключ - это индивидуальный код пункта меню для разработчиков
                  мобильного приложения. Для проверки принадлежности к
                  определенному пункту меню. Если изменить ключ – без
                  согласования с менеджером со стороны мобильного приложения,
                  может все сломаться!!
                </div>
              </v-card-text>
              <v-card-actions class="dialog-buttons">
                <v-btn @click="dialogDisable = false" style="width: 120px" outlined color="var(--app-green-1)">
                  Нет
                </v-btn>
                <v-btn @click="
                  disabledKey = false;
                dialogDisable = false;
                                                                                                            " style="width: 120px"
                  outlined color="var(--app-red-1)">
                  Да
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
        <div class="d-flex align-center mb-6">
          <v-switch v-model="appSection.isTestMode" color="var(--app-green-1)" hide-details></v-switch>
          <span class="switch-label">Отображать только в режиме разработчика</span>
        </div>
        <div class="d-flex align-center" v-if="appSection.key != 'main_page'">
          <v-switch v-model="appSection.isView" color="var(--app-green-1)" hide-details></v-switch>
          <span class="switch-label">Скрыть раздел</span>
        </div>
      </div>
    </v-form>

    <div class="container-block" style="width: 100%">
      <div class="container-block-title">Прикрепить иконки</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Иконка</th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px">
              <td class="text-left">iOS</td>
              <td class="text-left">
                Иконка будет отображаться на телефонах на платформе iOS
                <br />Прикрепить файл формата pdf
              </td>
              <td class="text-left">
                <v-btn v-if="!newImageIOS" class="button-accept" @click="onButtonClick">
                  Загрузить pdf
                </v-btn>
                <input v-if="!newImageIOS" ref="uploader" class="d-none" type="file" accept="application/pdf"
                  @change="onFileChanged" />

                <a v-else target="_blank" :href="imgSrcIOS">
                  <span v-if="newImageIOS.name">{{ newImageIOS.name }}</span>
                  <span v-else>Иконка</span>
                </a>
              </td>

              <td class="text-left">
                <v-btn icon @click="deleteImageIOS">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
            <tr style="height: 60px">
              <td class="text-left">Android</td>
              <td class="text-left">
                Иконка будет отображаться на телефонах на платформе Android
                <br />
                Прикрепить файл формата svg
              </td>
              <td class="text-left">
                <v-btn v-if="!newImageAND" class="button-accept" @click="onButtonClickAND">
                  Загрузить svg
                </v-btn>
                <input v-if="!newImageAND" ref="uploaderAND" class="d-none" type="file" accept="image"
                  @change="onFileChangedAND" />
                <img style="max-width: 50px; max-height: 50px" v-else :src="imgSrcAND" />
              </td>

              <td class="text-left">
                <v-btn icon @click="deleteImageAND">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Загрузите все изображения
      </v-alert>
      <v-divider></v-divider>
    </div>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn @click="saveAppSection" style="width: auto !important" class="button-accept">
          Сохранить
        </v-btn>
      </div>
      <div>
        <v-btn v-if="appSection.isRemovable" outlined @click="openDialogDelete" style="width: auto !important"
          color="var(--app-red-1)" class="button-accept-outlined">
          Удалить
        </v-btn>
      </div>
    </div>
    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить пункт меню?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn @click="dialogDelete = false" style="width: 120px" outlined color="var(--app-green-1)">
            Нет
          </v-btn>
          <v-btn @click="deleteAppSection" style="width: 120px" outlined color="var(--app-red-1)">
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>


export default {
  data: () => ({
    disabledKey: true,
    errImages: false,
    dialogDisable: false,
    appSection: {},
    pages: [],

    rules: [(value) => !!value || "Обязательно к заполнению"],
    dialogDelete: false,
    newImageIOS: null,
    imgSrcIOS: "",

    newImageAND: null,
    imgSrcAND: "",
  }),

  methods: {
    openDialogDelete() {
      this.dialogDelete = true;
    },

    back() {
      this.$router.push({ name: "AppSections" });
    },
    onButtonClick() {
      this.$refs.uploader.click();
    },
    onButtonClickAND() {
      this.$refs.uploaderAND.click();
    },

    onFileChanged(e) {
      this.errImages = false;
      this.newImageIOS = e.target.files[0];
      this.imgSrcIOS = URL.createObjectURL(this.newImageIOS);
    },
    onFileChangedAND(e) {
      this.errImages = false;
      this.newImageAND = e.target.files[0];
      this.imgSrcAND = URL.createObjectURL(this.newImageAND);
    },

    deleteImageIOS() {
      this.newImageIOS = null;
      this.imgSrcIOS = "";
    },
    deleteImageAND() {
      this.newImageAND = null;
      this.imgSrcAND = "";
    },
    getPages() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/page/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.pages = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    deleteAppSection() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/appSection", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            sectionId: this.$route.params.id,
          },
        })
        .then(() => {
          this.$router.push({ name: "AppSections" });
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getAppSection() {
      this.$axios
        .get(this.$store.getters.apiAdminPanelV2 + "/appSection", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            sectionId: this.$route.params.id,
          },
        })
        .then((res) => {
          this.appSection = res.data;

          this.appSection.isView = !res.data.isView;
          this.newImageIOS = this.appSection.iosIcon;
          this.newImageAND = this.appSection.androidIcon;
          this.imgSrcIOS = this.appSection.iosIcon;
          this.imgSrcAND = this.appSection.androidIcon;
          this.appSection.pageId = this.appSection.page ? this.appSection.page.id : ''
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },

    saveAppSection() {
      if (this.$refs.formFirst.validate()) {
        if (this.newImageIOS && this.newImageAND) {
          let formData = new FormData();
          formData.append("sectionId", this.appSection.id);
          formData.append("name", this.appSection.name);
          formData.append("shortName", this.appSection.shortName);
          formData.append("title", this.appSection.title);
          formData.append("iosIcon", this.newImageIOS);
          formData.append("androidIcon", this.newImageAND);
          formData.append("key", this.appSection.key);
          formData.append("isView", !this.appSection.isView);
          formData.append("isTestMode", this.appSection.isTestMode);

          if (this.appSection.isRemovable) {
            formData.append("pageId", this.appSection.pageId);
          }
          formData.append("key", this.appSection.key);

          this.$axios
            .post(
              this.$store.getters.apiAdminPanelV2 + "/appSection",
              formData,
              {
                headers: {
                  authorization: this.$store.getters.adminPanelHeaderAuth,
                },
              }
            )
            .then(() => {
              this.$router.push({ name: "AppSections" });
            })
            .catch((err) => {
              this.$store.commit("errorSet", true);
              this.$store.commit("errorTextSet", err);
            });
        } else {
          this.errImages = true;
        }
      }
    },
  },
  created() {
    this.getPages();
    this.getAppSection();
  },

  watch: {},
};
</script>
<style lang="scss" scoped>
.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }

    .container-main-checkbox {
      border: 1px solid rgba(0, 0, 0, 0.42);
      border-radius: 4px;
      padding-top: 20px;
      padding-left: 12px;
      margin-top: 0px !important;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.switch-label {
  font-size: 16px;
  color: #0000009a;
  margin-bottom: 2px;
}
</style>